/**
 * Documents des dossiers affectés au technicien.
 */
import { useQuery } from '@tanstack/react-query';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { DashboardLayout } from '@/components/dashboard/dashboard-layout';
import { listTechnicianDocuments } from '@/features/admin/admin-api';

export function TechnicianDocumentsPage() {
  const docs = useQuery({
    queryKey: ['technician', 'documents'],
    queryFn: listTechnicianDocuments,
  });

  return (
    <DashboardLayout variant="technicien" title="Documents">
      <Card>
        <CardHeader>
          <CardTitle>Documents de mes dossiers</CardTitle>
          <CardDescription>
            Toutes les pièces déposées sur les dossiers qui me sont affectés.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Fichier</TableHead>
                <TableHead>Type</TableHead>
                <TableHead>Statut</TableHead>
                <TableHead className="text-right">Uploadé le</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {docs.data?.length ? (
                docs.data.map((d) => (
                  <TableRow key={d.id}>
                    <TableCell className="font-medium">{d.filename}</TableCell>
                    <TableCell className="capitalize">
                      {d.documentType.replace(/_/g, ' ')}
                    </TableCell>
                    <TableCell>
                      <Badge
                        variant="outline"
                        className={
                          d.status === 'valide'
                            ? 'bg-green-100 text-green-800'
                            : d.status === 'refuse'
                              ? 'bg-red-100 text-red-800'
                              : d.status === 'a_completer'
                                ? 'bg-orange-100 text-orange-800'
                                : 'bg-blue-100 text-blue-800'
                        }
                      >
                        {d.status.replace('_', ' ')}
                      </Badge>
                    </TableCell>
                    <TableCell className="text-right text-sm text-gray-500">
                      {new Date(d.uploadedAt).toLocaleDateString('fr-FR')}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} className="text-center text-sm text-gray-500">
                    Aucun document pour le moment.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}
